import { Skeleton } from 'antd';
import { Col, Row } from 'antd';

import './cardSkeleton.scss';

export const CardSkeleton = () => {
    return (
        <Row className="skeleton-card">
            <Skeleton.Image active />
            <Col className="skeleton-text" span={8} xs={12} sm={14} md={16}>
                <Skeleton.Input active size="small" />
                <Skeleton.Input active size="small" block />
            </Col>
        </Row>
    );
};
